import { render, staticRenderFns } from "./Multistreaming.vue?vue&type=template&id=b89bce62&scoped=true&"
import script from "./Multistreaming.vue?vue&type=script&lang=js&"
export * from "./Multistreaming.vue?vue&type=script&lang=js&"
import style0 from "./Multistreaming.vue?vue&type=style&index=0&id=b89bce62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89bce62",
  null
  
)

export default component.exports